/**
 * AnalyticsPeriodTrigger - Unified date-range control for Analytics header
 * Renders a single button showing the current range; click opens a popover with ReportingPeriodBar.
 */
import React, { useState } from 'react';
import Popover from '../../shared/Popover.jsx';
import ReportingPeriodBar from '../../shared/ReportingPeriodBar.jsx';

export default function AnalyticsPeriodTrigger({ dateRangeDisplay }) {
  const [isOpen, setIsOpen] = useState(false);

  const triggerLabel = dateRangeDisplay || 'Select period';

  return (
    <Popover
      isOpen={isOpen}
      onClose={() => setIsOpen(false)}
      placement="bottom-start"
      offset={8}
      trigger={({ ref, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHaspopup }) => (
        <button
          ref={ref}
          type="button"
          aria-expanded={ariaExpanded}
          aria-haspopup={ariaHaspopup}
          aria-label="Reporting period"
          onClick={() => setIsOpen(true)}
          style={styles.trigger}
        >
          <span style={styles.triggerLabel}>{triggerLabel}</span>
          <span style={styles.chevron} aria-hidden>▾</span>
        </button>
      )}
    >
      <div style={styles.panel}>
        <ReportingPeriodBar onAfterChange={() => setIsOpen(false)} />
      </div>
    </Popover>
  );
}

const styles = {
  trigger: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 'var(--spacing-2)',
    minWidth: '200px',
    padding: 'var(--spacing-2) var(--spacing-3)',
    border: '1px solid var(--color-border-medium)',
    borderRadius: 'var(--radius-md)',
    backgroundColor: 'var(--color-bg-secondary)',
    color: 'var(--color-text-primary)',
    fontSize: 'var(--font-size-base)',
    fontWeight: 600,
    cursor: 'pointer',
    lineHeight: 1.3,
  },
  triggerLabel: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  chevron: {
    flexShrink: 0,
    color: 'var(--color-text-secondary)',
    fontSize: 'var(--font-size-sm)',
  },
  panel: {
    padding: 'var(--spacing-4)',
    backgroundColor: 'var(--color-bg-primary)',
    border: '1px solid var(--color-border-medium)',
    borderRadius: 'var(--radius-md)',
    boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
    minWidth: '320px',
  },
};
